<template>
  <v-card min-width="280px">
    <v-toolbar height="46px" flat>
      <h2 class="Notifications-header">{{ $t('notifications.sectionHeader') }}</h2>
    </v-toolbar>
    <Notification
      v-for="notification in notifications"
      :key="notification.notificationId"
      :notification="notification"
    />
    <p class="ma-0 pa-5" v-if="!notifications.length">{{ $t('notifications.emptyMessage') }}</p>
  </v-card>
</template>

<script>
import Notification from '@/components/ui/notifications/Notification'

export default {
  name: 'NotificationsMenu',
  components: {
    Notification
  },
  props: {
    notifications: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.Notifications-header {
  font-size: 18px;
  font-weight: 300;
}
</style>
